export function createClassesLegend(legendJson, id, title = null) {
    var div = document.createElement('div')
    div.className = 'map-legend'
    div.id = id
    if (title != null) {
        var titleDiv = document.createElement('b')
        titleDiv.innerHTML = title
        div.appendChild(titleDiv)
    }
    var legend = document.createElement('table')
    legend.className = 'legend-table'
    // for (var i = 0; i<Object.keys(legend_json).length; i++) {
    for (var key in legendJson) {
        var subDiv = document.createElement('div')
        var subSpan = document.createElement('span')
        var text = document.createElement('text')
        subSpan.style.backgroundColor = legendJson[key]
        text.textContent = key
        subDiv.appendChild(subSpan)
        subDiv.appendChild(text)
        div.appendChild(subDiv)
    }
    return div
}

export function createFlowLegend(gradient, texts, id, title = null) {
    var div = document.createElement('div')
    div.className = 'map-legend'
    div.id = id

    if (title != null) {
        var titleDiv = document.createElement('b')
        titleDiv.innerHTML = title
        div.appendChild(titleDiv)
    }
    var legend = document.createElement('table')
    legend.className = 'legend-table'
    var appendGradient = true
    for (let index = 0; index < texts.length; ++index) {
        var tr = document.createElement('tr')
        var th = document.createElement('th')
        th.className = 'tg-0lax'
        th.textContent = texts[index]
        if (appendGradient === true) {
            var thGradient = document.createElement('th')
            thGradient.className = gradient
            thGradient.rowSpan = texts.length
            tr.appendChild(thGradient)
            appendGradient = false
        }

        tr.appendChild(th)
        legend.appendChild(tr)
    }
    // console.log(div)

    div.appendChild(legend)
    return div
}
export function createMultipleFlowLegend(gradientList, textList, id, title = null) {
    var div = document.createElement('div')
    div.className = 'legend'
    div.id = id
    if (title != null) {
        var titleDiv = document.createElement('b')
        titleDiv.innerHTML = title
        div.appendChild(titleDiv)
    }
    for (let indexMultiple = 0; indexMultiple < gradientList.length; ++indexMultiple) {
        var legend = document.createElement('table')
        legend.className = 'legend-table'
        var appendGradient = true
        var gradient = gradientList[indexMultiple]
        var texts = textList[indexMultiple]
        for (let index = 0; index < texts.length; ++index) {
            var tr = document.createElement('tr')
            var th = document.createElement('th')
            th.className = 'tg-0lax'
            th.textContent = texts[index]
            if (appendGradient === true) {
                var thGradient = document.createElement('th')
                thGradient.className = gradient
                thGradient.rowSpan = texts.length
                tr.appendChild(thGradient)
                appendGradient = false
            }

            tr.appendChild(th)
            legend.appendChild(tr)
        }
        div.appendChild(legend)
    }

    return div
}
export function createLayerDescriptionBox(layer) {
    // console.log(layer.id + '-description')
    return createDescriptionBox(layer.title, layer.description, layer.id + '-description')
}

export function createDescriptionBox(title, text, id) {
    var description = document.createElement('div')
    description.className = 'description'
    description.id = id
    var titleEle = document.createElement('h5')
    titleEle.textContent = title
    description.appendChild(titleEle)
    var descEle = document.createElement('div')
    descEle.className='description-text'
    descEle.textContent = text
    description.appendChild(descEle)
    return description
}

import flatpickr from 'flatpickr'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
export var FlatpickerInstance = flatpickr('#date', {
    altInput: true,
    minDate: '01-01-1980',
    maxDate: '01-01-2020',
    plugins: [new MonthSelectPlugin({
        shorthand: true, // defaults to false
        dateFormat: 'F Y', // defaults to "F Y"
        altFormat: 'F Y', // defaults to "F Y"
        theme: 'light' // defaults to "light"})],

    })],
    onYearChange: function () {
        var flatpickrDate = FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Y-m-d')
        // dsiLayer.getSource().updateParams({ TIME: flatpickrDate })
        // spi3Layer.getSource().updateParams({ TIME: flatpickrDate })
        // spi6Layer.getSource().updateParams({ TIME: flatpickrDate })
        // hazardRainfedPixelTsLayer.changed()
        // adqiQ50Layer.changed()
        // adqiQ80Layer.changed()
        // zflVciImpactLayer.changed()
    },
    onChange: function () {
        // most Grace data is at the middle of the month
        // for better rounding set the selected date also to the middle of the month
        // if these changes for the grace-data, this should be changed accordingly.
        // flatpickr_instance.selectedDates[0].setDate(15)
        var flatpickrDate = FlatpickerInstance.formatDate(FlatpickerInstance.selectedDates[0], 'Y-m-d')
        // dsiLayer.getSource().updateParams({ TIME: flatpickrDate })
        // spi3Layer.getSource().updateParams({ TIME: flatpickrDate })
        // spi6Layer.getSource().updateParams({ TIME: flatpickrDate })
        // hazardRainfedPixelTsLayer.changed()
        // zflVciImpactLayer.changed()
        // adqiQ50Layer.changed()
        // adqiQ80Layer.changed()
        // console.log(flatpickr_instance.currentYear + '15')
        // console.log(flatpickr_instance.formatDate(flatpickr_instance.selectedDates[0], 'Ym15'))
        // flatpickr_instance.config.plugins = []
    }
})